export function getAreaHierarchyChain(data, areaId) {
	// Helper function to find an item by id
	function findById(id) {
		return data.find((item) => item.id === id);
	}

	// Helper function to find children of a given id
	function findChildren(id) {
		return data.filter((item) => item.parentId === id);
	}

	// Initialize the chain array
	const chain = [];

	// Start from the leaf node and go up to the root (parent chain)
	let current = findById(areaId);
	while (current) {
		chain.unshift({ ...current, relation: 'parent' });
		current = findById(current.parentId);
	}

	// Update the relation of the original areaId to 'self'
	const selfIndex = chain.findIndex((item) => item.id === areaId);
	if (selfIndex !== -1) {
		chain[selfIndex].relation = 'self';
	}

	// Add children of the original areaId
	const addChildren = (parentId) => {
		const children = findChildren(parentId);
		children.forEach((child) => {
			chain.push({ ...child, relation: 'child' });
			addChildren(child.id); // Recursively find deeper children
		});
	};
	addChildren(areaId);

	return chain;
}

//   // Example usage:
//   const data = [
//     { id: 1, parentId: null },
//     { id: 2, parentId: 1 },
//     { id: 3, parentId: 1 },
//     { id: 4, parentId: 2 },
//     { id: 5, parentId: 2 },
//     { id: 6, parentId: 3 }
//   ];

//   console.log(getHierarchyChain(data, 4));
//   // Output:
//   // [
//   //   { id: 1, parentId: null, relation: 'parent' },
//   //   { id: 2, parentId: 1, relation: 'parent' },
//   //   { id: 4, parentId: 2, relation: 'self' }
//   // ]
